import { Component, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModal } from '../componentes-funcionais/alerta-modal/alerta-modal.component';
import { ErroService } from 'src/app/service/erros/erro.service';
import Swal from 'sweetalert';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { GeradorRelatoriosService } from './gerador-relatorios.service';
declare var $: any;

@Component({
  selector: 'app-gerador-relatorios',
  templateUrl: './gerador-relatorios.component.html',
  styleUrls: ['./gerador-relatorios.component.css'],
})
export class GeradorRelatoriosComponent {
  formRelatorios: FormGroup = new FormGroup({});
  listaExecucao: any[] = [];
  detalhesParametros: any[] = [];
  dadosCritica: any = null;
  dadosOriginais: any[] = [];
  campoAtual: any = null;
  houveAlteracoes: boolean = false;
  listaTipoProcessamento: any;
  relatorioSelecionado: any = null;
  escondidoTemporariamente = false;
  tipoProgramaAtualCritica: string = '';
  private ultimoParametroAberto: { codigoPrograma: string; tipoPrograma: string } | null = null;
  camposEditados: { [chave: string]: { tipoPrograma: string; dados: any[] } } = {};

  parametosRelatorios: Parametros[] = [];

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private validaErro: ErroService,
    private geradorRelatoriosService: GeradorRelatoriosService
  ) {}

  ngOnInit(): void {
    this.formRelatorios = this.fb.group({
      tipoExecucao: ['', Validators.required],
    });

    this.buscarExecucao();
  }

  buscarExecucao() {
    this.spinner.show();
    this.geradorRelatoriosService.buscarExecucao().subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.listaExecucao = data;
      },
      error: (error) => {
        this.spinner.hide();

        Swal({
          title: 'Erro!',
          text: error.error?.Mensagem || 'Não foi possível buscar os tipos de férias.',
          icon: 'error',
        });
      },
    });
  }

  buscarParametros() {
    const valor = this.formRelatorios.get('tipoExecucao')?.value;

    this.camposEditados = {};

    this.spinner.show();
    this.geradorRelatoriosService.buscarParametros(valor).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.listaTipoProcessamento = data;
        this.parametosRelatorios = data;
      },
    });
  }

  onTipoExecucaoChange() {
    const valor = this.formRelatorios.get('tipoExecucao')?.value;
    if (valor) {
      this.buscarParametros();
    }
  }

  abrirParametros(item: any) {
    const { CodigoTipoExecucao, CodigoPrograma, TipoPrograma } = item;

    if (!CodigoTipoExecucao || !CodigoPrograma || !TipoPrograma) {
      console.warn('Dados incompletos para buscar os detalhes.');
      return;
    }

    this.limparDadosEditados(CodigoPrograma);

    this.ultimoParametroAberto = { codigoPrograma: CodigoPrograma, tipoPrograma: TipoPrograma };
    this.relatorioSelecionado = item;
    this.spinner.show();

    this.geradorRelatoriosService
      .buscarProgramaDetalhe(CodigoTipoExecucao, CodigoPrograma, TipoPrograma)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          this.detalhesParametros = Array.isArray(data) ? data : [data];
        },
        error: (error) => {
          this.spinner.hide();
          Swal({
            title: 'Erro!',
            text: error.error?.Mensagem || 'Não foi possível buscar os detalhes do programa.',
            icon: 'error',
          });
        },
      });
  }

  private limparDadosEditados(codigoPrograma: string) {
    Object.keys(this.camposEditados).forEach((key) => {
      if (key.startsWith(`${codigoPrograma}_`)) {
        delete this.camposEditados[key];
      }
    });
  }

  filtrarInput(event: KeyboardEvent, tipoCampo: string): boolean {
    if (
      event.key === 'Backspace' ||
      event.key === 'Tab' ||
      event.key === 'Delete' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight'
    ) {
      return true;
    }

    if (tipoCampo === 'NUMERICO') {
      const pattern = /[0-9]/;
      return pattern.test(event.key);
    }

    if (tipoCampo === 'ALFA') {
      return event.key !== '\n' && event.key !== '\r';
    }

    return true;
  }

  validarCampo(campo: any): void {
    if (campo.TipoCampo === 'NUMERICO') {
      campo.Formato = campo.Formato.replace(/[^0-9]/g, '');
    }

    if (campo.Formato && campo.Formato.length > campo.Tamanho) {
      campo.Formato = campo.Formato.substring(0, campo.Tamanho);
    }

    this.verificarAlteracao();
  }

  processarConteudo() {
    if (!this.dadosCritica || !this.dadosCritica.length || !this.dadosCritica[0].Conteudo) {
      return;
    }

    const conteudo = this.dadosCritica[0].Conteudo;
    let posicaoAtual = 0;

    const camposOrdenados = [...this.dadosCritica].sort((a, b) => a.Campo - b.Campo);

    camposOrdenados.forEach((campo) => {
      const tamanho = campo.Tamanho;
      let parte = conteudo.substr(posicaoAtual, tamanho);

      if (campo.TipoCampo === 'NUMERICO') {
        parte = parte.replace(/[^0-9]/g, '');
      }

      campo.Formato = parte;
      posicaoAtual += tamanho;
    });
  }

  abrirCriticaModal(campo: any) {
    const linha = campo.Linha;
    const codigoPrograma = campo.CodigoPrograma || campo.Codigo;
    const tipoProgramaAtual = campo.TipoPrograma;
    const chave = `${codigoPrograma}_${linha}`;

    this.tipoProgramaAtualCritica = tipoProgramaAtual;
    this.escondidoTemporariamente = true;

    const dadosSalvos = this.camposEditados[chave];

    if (dadosSalvos && dadosSalvos.tipoPrograma === tipoProgramaAtual) {
      this.dadosCritica = [...dadosSalvos.dados];
      this.dadosOriginais = JSON.parse(JSON.stringify(dadosSalvos.dados));
      this.exibirModal();
      return;
    }

    this.spinner.show();
    this.geradorRelatoriosService.buscarCriticaParametros(linha, codigoPrograma).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.dadosCritica = this.deepCopy(data);
        this.dadosOriginais = this.deepCopy(data);

        this.campoAtual = campo;

        if (this.dadosCritica.length > 0) {
          this.dadosCritica[0].Conteudo = campo.Conteudo;
          this.dadosOriginais[0].Conteudo = campo.Conteudo;
        }

        this.processarConteudo();
        this.exibirModal();
      },

      error: (error) => {
        this.spinner.hide();
        Swal({
          title: 'Erro!',
          text: error.error?.Mensagem || 'Não foi possível buscar os dados da crítica.',
          icon: 'error',
        });
      },
    });
  }
  private deepCopy(obj: any): any {
    if (!obj) return obj;
    return JSON.parse(JSON.stringify(obj));
  }

  verificarAlteracao() {
    this.houveAlteracoes = true;
  }

  fecharSemSalvar(event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.restaurarDadosEFechar();
  }

  private verificarMudancasReais(): boolean {
    if (!this.dadosCritica || !this.dadosOriginais) return false;

    return JSON.stringify(this.dadosCritica) !== JSON.stringify(this.dadosOriginais);
  }

  private restaurarDadosEFechar() {
    if (this.dadosCritica && this.dadosOriginais) {
      this.dadosCritica.forEach((item: any, index: number) => {
        Object.keys(item).forEach((key) => {
          this.dadosCritica[index][key] = this.dadosOriginais[index][key];
        });
      });
    }
    this.fecharModal();
    this.houveAlteracoes = false;
  }

  reconstruirConteudo(): string {
    if (!this.dadosCritica || !this.dadosCritica.length) return '';

    const camposOrdenados = [...this.dadosCritica].sort((a, b) => a.Campo - b.Campo);
    let conteudoReconstruido = '';

    camposOrdenados.forEach((campo) => {
      let valor = campo.Formato || '';

      if (campo.TipoCampo === 'NUMERICO') {
        valor = valor.replace(/[^0-9]/g, '').padStart(campo.Tamanho, '0');
      } else {
        valor = valor.padEnd(campo.Tamanho, ' ');
      }

      conteudoReconstruido += valor.substring(0, campo.Tamanho);
    });

    return conteudoReconstruido;
  }

  salvarEFechar(event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const novoConteudo = this.reconstruirConteudo();

    if (this.dadosCritica.length > 0) {
      this.dadosCritica[0].Conteudo = novoConteudo;
      this.dadosOriginais[0].Conteudo = novoConteudo;
    }

    if (this.campoAtual) {
      this.campoAtual.Conteudo = novoConteudo;
    }

    this.salvarCritica();
    this.fecharModal();

    Swal({
      title: 'Sucesso!',
      text: 'As alterações foram salvas com sucesso.',
      icon: 'success',
      timer: 2000,
    });
  }

  private fecharModal() {
    $('#modal-critica').modal('hide');
    this.houveAlteracoes = false;
    this.escondidoTemporariamente = false;
  }

  salvarCritica() {
    if (!this.dadosCritica?.length) return;

    const { CodigoPrograma, Linha } = this.dadosCritica[0];
    const chave = `${CodigoPrograma}_${Linha}`;

    const novoConteudo = this.reconstruirConteudo();
    this.dadosCritica[0].Conteudo = novoConteudo;

    this.camposEditados[chave] = {
      tipoPrograma: this.tipoProgramaAtualCritica,
      dados: JSON.parse(JSON.stringify(this.dadosCritica)),
    };

    this.atualizarDetalhesParametros(CodigoPrograma, Linha, novoConteudo);
  }

  private atualizarDetalhesParametros(codigoPrograma: string, linha: number, novoConteudo: string) {
    const item = this.detalhesParametros.find(
      (p) => p.CodigoPrograma === codigoPrograma && p.Linha === linha
    );

    if (item) {
      Object.assign(item, { Conteudo: novoConteudo });
    }
  }

  exibirModal() {
    const modalCritica = document.getElementById('modal-critica');
    if (modalCritica) {
      (modalCritica as any).classList.add('show');
      modalCritica.setAttribute('style', 'display: block;');
      modalCritica.removeAttribute('aria-hidden');
    }
  }
}

export interface Parametros {
  CodigoPrograma: string;
  TipoPrograma: string;
  DescricaoCampo: string;
  Conteudo: string;
}
